.container {
  user-select: none;
  --slide-distance: 20%;
}

.header {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  composes: slideLeft from global;
}

.searchInput {
  width: 300px;
}

.addButton {
  text-align: right;
}

.clearIcon {
  cursor: pointer;
}
.clearIcon:hover {
  color: red;
}
